<template>
    <Header
        :elements="countElements"
        :current="countElements"
    ></Header>
    <Pay
        formSlug="trademark-revival"
        stepBack="step-3"
        @init="init"
    ></Pay>
</template>

<script>
import Header from '@/components/Header-Short-New.vue'
import Pay from '@/components/Pay.vue'
import {to_top} from "@/helper";

export default {
    components: {
        Header,
        Pay
    },
    mounted() {
        to_top()
    },
    data() {
        return {
            classes: []
        }
    },
    methods: {
        init(data) {
            this.classes = data.classes
        }
    },
    computed: {
        countElements() {
            return this.classes.length ? 5 + this.classes.length : 0
        }
    }
}
</script>
